import React, { useState } from 'react'
import { AllCustomTypeComponent } from '../Components/CustomType/AllCustomTypeComponent';
import { AddCustomTypeComponent } from '../Components/CustomType/AddCustomTypeComponent';
import { EditCustomTypeComponent } from '../Components/CustomType/EditCustomTypeComponent';

export const CustomType = ({ setLoading, showMessage }) => {
  // ======================================================================
  const [view, setView] = useState('All');
  const [currentPage, setCurrentPage] = useState(1);
  const [version, setVersion] = useState(0);
  const [parentId, setParentId] = useState(0);
  const [parentTitle, setParentTitle] = useState("");
  const [oldParentId, setOldParentId] = useState([]);
  const [oldParentTitle, setOldParentTitle] = useState([]);

  const [id, setId] = useState(0);
  // ======================================================================
  return (
    <>
      {view == "All" ?
        <AllCustomTypeComponent
          parentId={parentId}
          parentTitle={parentTitle}
          setLoading={setLoading}
          showMessage={showMessage}
          version={version}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          onAddClick={() => setView("Add")}
          onDetailsClick={
            (id, title) => {
              setOldParentId([...oldParentId, parentId]);
              setOldParentTitle([...oldParentTitle, parentTitle]);
              setParentId(id);
              setParentTitle(title);
              setVersion(version + 1);
            }}
          onBackClick={
            () => {
              setParentId(oldParentId[oldParentId.length - 1]);
              setParentTitle(oldParentTitle[oldParentTitle.length - 1]);

              setOldParentId((oldParentId) => oldParentId.slice(0, -1));
              setOldParentTitle((oldParentTitle) => oldParentTitle.slice(0, -1));
              
              setVersion(version + 1);
            }}
          onEdit={(id) => { setId(id); setView("Edit") }}
          onRowDeleted={() => { setVersion(version + 1); }}
        /> : (view === "Add" ? (
          <AddCustomTypeComponent
            setLoading={setLoading}
            showMessage={showMessage}
            parentId={parentId}
            rowInserted={() => {
              setView("All"); if (currentPage != 1)
                setCurrentPage(1);
              else
                setVersion(version + 1);
            }}
            cancelInsert={() => { setView("All"); }} />
        ) :
          (
            view === "Edit" ? (
              <EditCustomTypeComponent
                setLoading={setLoading}
                showMessage={showMessage}
                id={id}
                rowUpdated={() => { setView("All"); setVersion(version + 1); }}
                cancelEdit={() => { setView("All"); }} />
            ) : (
              <></>
            )
          ))
      }
    </>
  )

}
